import { writable } from 'svelte/store';

export const loginSession = writable(undefined);
export const frontendConfig = writable({});
export const busySpinner = writable(false);
